<template>
  <CollapsePanel
    ref="container"
    class="glodrawer"
    :class="[globals_drawer.id, { glodrawer_open: l_open }]"
    :open="l_open"
    :toRight="true"
    :focusMode="true"
    :noTrigger="true"
    :hasOpener="false"
    tabindex="0"
    :toggleFn="
      bool => {
        if (!bool) {
          handleEsc()
        }
      }
    "
    style="--inner-shadow: var(--drawer-panel-shadow); --open-width: var(--drawer-panel-width)"
    @keydown.esc="handleEsc"
    @mouseenter="focusPanel"
  >
    <template #content>
      <div
        class="csst icon_btn clr-greys mdi mdi-close glodrawer_close clr-grey"
        @click="close"
      >
        <div
          class="csst_content text-nowrap clr-white"
          style="transform: translate(-100%); left: -0.25rem"
          v-html="$t('common.close_key', { key: 'Esc' })"
        ></div>
      </div>
      <TrainerHandHistoryItem
        v-if="globals_drawer.id === 'trainer_hand_history_item'"
        class="anim-fade-in"
      />
      <HandDetail
        v-if="globals_drawer.id === 'analyze_handV4'"
        :handId="globals_drawer.content.hand_id"
      />
      <UploadLimitReachedNote
        v-else-if="globals_drawer.id === 'upload-boxes' && upload_limit_reached"
        class="anim-fade-in"
      />
      <UploadBoxes
        v-else-if="globals_drawer.id === 'upload-boxes'"
        class="anim-fade-in glodrawer_uploadboxes"
        :class="{ 'no-events opacity_4': upload_limit_reached }"
        :tab="globals_drawer.tab"
      />

      <div
        v-if="globals_drawer.id === 'upload-boxes'"
        class="position-absolute text-smallest"
        style="bottom: 0; right: 0.5rem; color: var(--clr-black-2); z-index: 6"
      >
        {{ 'v2-alpha' }}
      </div>
    </template>
    <template #after>
      <portal-target name="custom_drawer_after" />
    </template>
  </CollapsePanel>
</template>
<script>
import UploadBoxes from '@/components/UploadBoxes/UploadBoxes'
import UploadLimitReachedNote from '@/components/Notices/UploadLimitReachedNote'
import CollapsePanel from '@/components/CollapsePanel/CollapsePanel'
import tier_mix from '@/mixins/tier_mix'
import TrainerHandHistoryItem from '@/components/Trainer/TrainerHandHistoryItem'
import HandDetail from '@/components/hhv3/Analyzer/HandDetail/HandDetail.vue'

export default {
  name: 'Drawer',
  components: {
    CollapsePanel,
    TrainerHandHistoryItem,
    HandDetail,
    UploadBoxes,
    UploadLimitReachedNote,
  },
  mixins: [tier_mix],
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleEsc() {
      if (this.maximized) {
        this.closeMaximized()
        return
      }
      this.close()
    },
    close() {
      this.$store.dispatch('globals_drawer', {
        open: false,
        maximized: false,
        content: {},
        id: '',
      })
    },
    closeMaximized() {
      this.$store.dispatch('globals_drawer', {
        ...this.globals_drawer,
        maximized: false,
      })
    },
    focusPanel() {
      if (this.l_open) {
        this.$refs.container.$el.focus()
      }
    },
    handleClickOutside(event) {
      const CLOSABLE_ON_CLICK_OUTSIDE = ['upload-boxes']

      if (
        !CLOSABLE_ON_CLICK_OUTSIDE.includes(this.globals_drawer.id) ||
        // TODO: Respect only particular popups (I.e. opened from the UploadBoxes)
        event.target.closest('.gw_pop_menu_content')
      ) {
        return
      }
      if (this.l_open && !this.$refs.container.$el.contains(event.target)) {
        this.close()
      }
    },
  },
  computed: {
    globals_drawer() {
      return this.$store.getters.globals_drawer
    },
    upload_limit_reached() {
      const allGone = this.allSubs.every(i => {
        const limit = i.hands_limit
        const usage = i.hands_usage.hands_used
        const r = limit === usage
        return r
      })
      return allGone
    },
    l_open() {
      return this.globals_drawer.open
    },
    maximized() {
      return this.globals_drawer.maximized
    },
  },
  watch: {
    '$route.name': {
      handler: 'close',
      immediate: false,
    },
    l_open() {
      this.focusPanel()
    },
  },
}
</script>

<style lang="scss" scoped>
.glodrawer {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: var(--z-index-drawer);
  height: var(--vh-3);
  --drawer-panel-width: 21.5rem;
  --drawer-panel-shadow: 0px 0px 0px 0px transparent;
  --maximized-content-left: var(--drawer-panel-width);
  --maximized-content-right: -100vw;
  --maximized-width: clamp(52rem, 76rem, calc(100vw - var(--drawer-panel-width) - 3rem));
  &.upload-boxes {
    --drawer-panel-width: 28rem;
  }
  &_open {
    --drawer-panel-shadow: 0px 0px 12px 2px var(--clr-black-0);
  }
  &_uploadboxes {
    // margin-top: -2.5rem;
    z-index: 2;
  }
  &_top {
    &_portal-content {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
    }
  }
  &_close {
    z-index: 4;
    font-size: 1.25rem;
    width: 2rem;
    height: 2rem;
    display: flex;
    position: absolute;
    right: 0.5rem;
    top: 0.375rem;
  }
  &_maximized {
    --drawer-panel-shadow: 0px 0px 12px 2px var(--clr-black-0);

    &_content {
      position: fixed;
      display: flex;
      justify-content: center;
      background: var(--clr-black-0-1);
      width: var(--maximized-width);
      right: var(--maximized-content-right);
      bottom: 0;
      height: var(--vh-3);
      transition: 0.22s;
      z-index: 2;
      &_open {
        --maximized-content-right: var(--drawer-panel-width);
      }
      &_opener {
        position: absolute !important;
        left: 0.5rem;
        top: 0.5rem;
        z-index: 3;
        padding: 0.25rem;
        font-size: 1.5rem;
        color: var(--clr-white-0);
      }
    }
    &_overlay {
      position: fixed;
      right: 0;
      bottom: 0;
      z-index: 1;
      background: rgba(0, 0, 0, 0.5);
      opacity: 1;
      height: var(--vh-3);
      width: 300vw;
      transition: opacity 0.22s;
      &_invisible {
        opacity: 0;
        width: 0vw;
        animation: delayShrink 0.22s;
        @keyframes delayShrink {
          0% {
            width: 300vw;
          }
          1000% {
            width: 300vw;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 520px) {
  .glodrawer {
    --drawer-panel-width: 100vw !important;
  }
}

@media (max-width: 1023px) {
  .glodrawer {
    top: 0;
    bottom: unset;
    height: var(--vh-3);
    --maximized-content-right: -200vw;
    &_maximized {
      --maximized-content-left: 0;
      &_content {
        top: 0;
        &_open {
          z-index: 4;
          --maximized-content-right: 0;
        }
        &_opener {
          position: absolute !important;
          left: 0.5rem;
          top: 0.5rem;
          z-index: 3;
          padding: 0.25rem;
          font-size: 1.5rem;
          color: var(--clr-white-0);
        }
      }
      &_overlay {
        display: none;
      }
    }
  }
}
</style>
